/*@ngInject*/
const RevisionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.processGetResponseData = function (responseData) {
        let revision = $(responseData);

        return {
            revNumber: revision.find('revNumber').text(),
            buildBranch: revision.find('buildBranch').text(),
            buildTime: revision.find('buildTime').text()
        };
    };

    this.getRevision = function () {
        let url = '/xml/revision_info.xml';

        return this.get(url);
    };
};

angular.module('umCore')
    .service('revisionRepository', RevisionRepository);
